import { createElementBlock as t, openBlock as n, createElementVNode as e } from "vue";
import l from "./index289.js";
const r = {}, c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};
function s(a, o, d, f, i, p) {
  return n(), t("svg", c, o[0] || (o[0] = [
    e("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      e("path", {
        fill: "#FFF9D5",
        d: "M15 35.35A15.58 15.58 0 0 0 29.419 45C38.023 45.002 45 38.046 45 29.467 45 21.342 38.74 14.683 30.766 14c3.97 5.446 3.507 13.104-1.42 18.016-3.882 3.87-9.474 4.97-14.346 3.334Z"
      }),
      e("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        d: "M30.876 12.755c8.668.742 15.377 7.985 15.377 16.712 0 9.27-7.538 16.785-16.831 16.783a16.828 16.828 0 0 1-15.575-10.424c-.407-.991.539-2.002 1.554-1.66 4.556 1.53 9.615.404 13.066-3.036a12.637 12.637 0 0 0 1.292-16.394c-.631-.866.049-2.073 1.117-1.981Zm-13.16 24.477-.349-.046.156.24a14.333 14.333 0 0 0 11.899 6.324c7.915.002 14.331-6.395 14.331-14.283l-.004-.327c-.142-6.3-4.396-11.638-10.254-13.363l-.266-.075.141.307a15.137 15.137 0 0 1-3.138 16.892 15.204 15.204 0 0 1-12.517 4.33Z"
      })
    ], -1)
  ]));
}
const u = /* @__PURE__ */ l(r, [["render", s]]);
export {
  u as default
};
